
    import React from "react";
    import {SoonStyled } from './styled';
  
    type Props = {
    };

    class Soon extends React.PureComponent<Props, any> {
      render() {
        return (
          <SoonStyled>
          Soon ...
          </SoonStyled>
        );
      }
    }
    export default Soon;
    
    